import { toast } from "sonner";

const AUTH_ERROR_PATTERNS = [
  "not authenticated",
  "401",
  "unauthorized",
  "jwt expired",
  "invalid jwt",
  "session expired",
  "invalid claim",
  "no session",
  "auth session missing",
] as const;

export function isAuthError(error: unknown): boolean {
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    return AUTH_ERROR_PATTERNS.some((pattern) => msg.includes(pattern));
  }
  if (typeof error === "object" && error !== null && "status" in error) {
    return (error as { status: number }).status === 401 || (error as { status: number }).status === 403;
  }
  return false;
}

export function showAuthErrorToast() {
  toast.error("Sign in required", {
    description: "Please sign in to access this feature.",
    action: {
      label: "Sign In",
      onClick: () => { window.location.href = "/auth"; },
    },
  });
}

// Keys that carry per-user state and must not leak across users on a shared
// device. Per-device flags (model migration, opt-ins) are intentionally kept.
const USER_SCOPED_KEYS = [
  "exos_saved_business_contexts",
  "exos_model_config",
] as const;
const USER_SCOPED_PREFIXES = ["exos_draft_"] as const;

export function clearUserScopedStorage(): void {
  try {
    for (const key of USER_SCOPED_KEYS) {
      localStorage.removeItem(key);
    }
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && USER_SCOPED_PREFIXES.some((p) => k.startsWith(p))) {
        toRemove.push(k);
      }
    }
    for (const k of toRemove) localStorage.removeItem(k);
  } catch {
    // storage unavailable — ignore
  }
}
